import Dialog from "dialog";
import template from "../html/dialog-config-thermostat.html";
import css from "../css/dialog-config-thermostat.css";

class ConfigThermostatDialog extends Dialog {
	static get template() {
		return template;
	}
	static get css() {
		return css;
	}
	static constructor() {
		customElements.define("fulljs-dialog-config-thermostat", ConfigThermostatDialog);
	}
	constructor() {
		super();

		document.addEventListener("onupdatedevices", this.onupdatedevices_handler.bind(this));

		this.onupdatedevices_handler({detail: application.devices});

		this.show();
	}
	onupdatedevices_handler(event) {
		var devices = event.detail;

		this.textboxDeviceID.value = devices.thermostat.id;
		this.textboxDeviceStatus.value = devices.thermostat.status;
		this.spinnerPercentage.value = devices.thermostat.percentage;
		this.dropdownlistMode.selectedIndex = devices.thermostat.mode;
		this.textboxVoltage.value = devices.thermostat.voltage;
		this.textboxCurrent.value = devices.thermostat.current;
		this.textboxPower.value = devices.thermostat.power;
        }
	buttonClose_click(event) {
		this.close();
	}
	spinnerPercentage_change(event) {
		server.rcall("RM_thermostat_setPercentage", this.spinnerPercentage.value).catch(function(result) {
			alert(result);
		});
	}
	dropdownlistMode_change(event) {
		server.rcall("RM_thermostat_setMode", this.dropdownlistMode.selectedIndex).catch(function(result) {
			alert(result);
		});
	}
}

ConfigThermostatDialog.constructor();

export default ConfigThermostatDialog;